import { h, Component } from 'preact';
import {Motion, spring,presets} from 'preact-motion';

export default class Bubble extends Component{
	constructor(props) {
		super(props);
		this.state = {hidden:false,removed:true};
	}

	componentWillReceiveProps(props) {
		
	}

	open = () => {
		console.log('opening inside open');
		this.setState({removed:false,hidden:false});
	}

	close = () => {
		this.setState({hidden:true});
	}
	
	rested = () => {
		var {hidden,} = this.state;
		if(hidden){
			console.log('removing completely');
			if(this.props.handler){
				this.props.handler();
			}
			this.setState({removed:true,hidden:false});
		}
	}

	componentDidMount() {
		// setTimeout(()=>{
		// 	console.log('opening now',this,this.dm);
		// 	this.open();
		// },4000);
	}

	


	render() {
		var {hidden} = this.state;
		var removed = !this.props.msg;
		var {msg} = this.props;
		if(removed){
			return null;
		}

		return (<div>
			<Motion defaultStyle={{x:0}}  style={{x:spring(((hidden)?0:1),{stiffness: 300, damping:11})}} onRest={this.rested}>
				{
					({x})=>{
						//console.log('x interpolation',x,this.dm);
						return (<div  style={{transform:`scale(${x},${x})`}}
						className={process.env["proactive-bubble"]} 
					
						onClick={this.close}>
								
									{this.props.msg}
						</div>);
					}
				}
			</Motion>
		</div>
			
			);
	}
}


// WEBPACK FOOTER //
// ./Bubble.jsx